import { useEffect, useState } from "react";
import "../styles/Coberturas.css";
import CoberturasCards from "./CoberturasCards";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import { ButtonNext, ButtonPrevious } from "../../../../assets/icons/Icons";

import { Card } from "../../../../components/card/Card";

const Coberturas = ({ coberturas, coberturasDesc }) => {
  const [cobertura, setCobertura] = useState();
  const [coberturaDesktop, setcoberturaDesktop] = useState();

  const setCards = () => {};

  const responsive = {
    320: {
      items: 1,
    },
    576: {
      items: 1,
    },
    768: {
      items: 1,
    },
    992: {
      items: 2,
    },
    1200: {
      items: 3,
    },
    1400: {
      items: 3,
    },
    1600: {
      items: 3,
    },
    1800: {
      items: 3,
    },
  };

  const handleModal = (e) => {
    alert("modal" + e);
  };

  const onSlideChangedCobertura = (e) => {
    if (e.isNextSlideDisabled) {
      document.getElementsByClassName(
        "btn__next__coberturas"
      )[0].style.display = "none";
      document.getElementsByClassName(
        "btn__prev__coberturas"
      )[0].style.display = "block";
    } else if (e.isPrevSlideDisabled) {
      document.getElementsByClassName(
        "btn__prev__coberturas"
      )[0].style.display = "none";
      document.getElementsByClassName(
        "btn__next__coberturas"
      )[0].style.display = "block";
    } else {
      document.getElementsByClassName(
        "btn__next__coberturas"
      )[0].style.display = "block";
      document.getElementsByClassName(
        "btn__prev__coberturas"
      )[0].style.display = "block";
    }
  };

  useEffect(() => {
    if (coberturas?.length < 1 || coberturas === undefined) return;
    let arregloCobertura = [];
    let arregloCoberturaDesktop = [];
    coberturas?.forEach((element) => {
      let arregloDescripcionesCobertura = [];
      let arregloDescripcionesCoberturadesktop = [];
      coberturasDesc?.forEach((desc) => {
        if (desc.idCobertura === element.id) {
          arregloDescripcionesCobertura.push(desc);
          arregloDescripcionesCoberturadesktop.push(desc);
        }
      });
      arregloCobertura.push(
        <CoberturasCards
          cobertura={element}
          coberturasDesc={arregloDescripcionesCobertura}
        />
      );
      arregloCoberturaDesktop.push({
        cobertura: element,
        coberturasDesc: arregloDescripcionesCobertura,
      });
    });
    setCobertura(arregloCobertura);
    setcoberturaDesktop(arregloCoberturaDesktop);
  }, [coberturas, coberturasDesc]);

  return (
    <>
      <div id="coberturas">
        <div
          className="homeout__coberturas container"
          style={{ paddingBottom: "3rem" }}
        >
          <h2 style={{ color: "var(--green)" }}>¿Cómo te protege tu seguro?</h2>
          <p>
            Haz clic en "Conoce más" para consultar los detalles de cada una de
            las coberturas
          </p>
          <div className="div__carousel__coberturas">
            {cobertura?.length > 0 && (
              <AliceCarousel
                items={cobertura}
                responsive={responsive}
                centerMode={true}
                disableDotsControls
                onSlideChanged={onSlideChangedCobertura}
                renderPrevButton={() => {
                  return (
                    <div className="btn__prev__coberturas">
                      <ButtonPrevious />
                    </div>
                  );
                }}
                renderNextButton={() => {
                  return (
                    <div className="btn__next__coberturas">
                      <ButtonNext />
                    </div>
                  );
                }}
              />
            )}
          </div>
        </div>

        {/* <div className=" d-none d-lg-block">
          <div className="homeout__coberturas container">
            <h2 style={{ color: 'var(--green)' }}>¿Cómo te protege tu seguro?</h2>
            <p>Haz clic en "Conoce más" para consultar los detalles de cada una de las coberturas</p>
            <div className="container ">
              <div className="row row align-items-start g-3 ">
                {coberturaDesktop?.length > 0 &&
                  coberturaDesktop.map((carInfo, index) => {
                    return (
                      <Card
                        key={index + '-card'}
                        data={carInfo}
                        textoBoton="CONOCE MÁS"
                        Onclick={(e) => handleModal(e)}
                      />
                    );
                  })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="d-lg-none">
        <div id="coberturas">
          <div className="homeout__coberturas container  ">
            <h1>¿Cómo te protege tu seguro?</h1>
            <p>Haz clic en "Conoce más" para consultar los detalles de cada una de las coberturas</p>
            {cobertura?.length > 0 && (
              <AliceCarousel
                mouseTracking
                items={cobertura}
                responsive={responsive}
                centerMode={true}
                disableDotsControls
                onSlideChanged={onSlideChangedCobertura}
                infinite={true}
                renderPrevButton={() => {
                  return (
                    <div className="btn__prev__coberturas">
                      <ButtonPrevious />
                    </div>
                  );
                }}
                renderNextButton={() => {
                  return (
                    <div className="btn__next__coberturas">
                      <ButtonNext />
                    </div>
                  );
                }}
              />
            )}

            
          </div>
        </div> */}
      </div>
    </>
  );
};

export default Coberturas;
